<template>
   
 
  <el-dialog
  v-model="showTyC"
  destroy-on-close
  width="55%" 
  center
  custom-class="dialogado">

    <template v-if="aviso=='aviso'">
      <div class="inner"> 
          <h6 class="ereso" > Nuestro Aviso de Privacidad </h6>
            <p class="estas">
              
             CHIESI MEXICO, S.A. DE C.V. (“CHIESI”), con domicilio en Avenida Coyoacán 1622 Edificio 2 Piso 1- 208a Colonia del Valle, Delegación Benito Juárez, Ciudad de México, C.P 03100, le informa a continuación los lineamientos para la protección de la información que Usted proporciona a la Empresa, de conformidad con las disposiciones de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (en adelante la “Ley”) su Reglamento y los Lineamientos para el Aviso de Privacidad.
<br><br>
Este documento revela la política de privacidad para el Tratamiento de Datos Personales recolectados por la Empresa (el “Aviso de Privacidad”). Cualquier información que sea recolectada por la Empresa de Usted será clasificada por la Empresa conforme a las siguientes categorías: “Datos Personales” – significa cualquier información escrita o electrónica concerniente a una persona física identificada o identificable. La información será considerada identificada o identificable si incluye alguno de los siguientes elementos:
<br><br>
a) Datos de Identificación, como su nombre completo, firma autógrafa, R.F.C., C.U.R.P., edad, género, número de identificación, lugar y fecha de nacimiento, estado civil, imagen digital o fotográfica, huella dactilar.
<br><br>
b) Datos particulares de contacto, como su domicilio, correo electrónico, teléfono fijo y teléfono celular.
<br><br>
c) Datos financieros, como su número de cuenta bancaria.
<br><br>
d) Video Grabaciones, Chiesi podrá video grabar testimonios, declaraciones u opiniones.
<br><br>
Los Datos Personales no incluyen información que se encuentra públicamente disponible.
<br><br>
“Datos Personales Sensibles” – significa cualquier Dato Personal referente a la salud, preferencia sexual, origen racial o étnico, información genética, creencias religiosas, filosóficas y morales, afiliación sindical, opiniones políticas o cualquier información identificada o identificable que afecte a la esfera más íntima de su titular, o cuya utilización indebida pueda dar origen a discriminación o conlleve un riesgo grave a dicha persona.
Chiesi tratará Testimonios, declaraciones, efectos terapéuticos de medicamentos y cualquier otra circunstancia que tenga que ver con su experiencia personal con su padecimiento, o bien el de un familiar cercano suyo como datos Sensibles.
<br><br>
Tratamiento de Datos Personales
<br><br>
Los datos personales que tratamos, los destinamos únicamente en función del cumplimiento de las siguientes:
<br><br>
A. Finalidades Primarias o Necesarias: siendo aquellas necesarias en virtud de la invitación de Chiesi, es decir para: (a) compartir durante el evento la experiencia que ha tenido como Profesional de la Salud/paciente; (b) dar a conocer las vivencias y retos que como Profesional de la salud/paciente ha enfrentado; (c) enriquecer a los asistentes con las enseñanzas que como Profesional de la Salud/paciente ha tenido derivado de una condición médica específica.
<br><br>
B. Finalidades Secundarias o No Necesarias: aquellas que no son necesarias o relacionadas con la relación contractual que tiene con Chiesi, y que usted solicita voluntariamente: (a) invitarlo a participar en eventos, ferias de salud, promociones, concursos y talleres informativos no laborales; (b) para fines estadísticos; (c) realizar encuestas.
<br><br>
¿Puedo negarme a las Finalidades Secundarias?
<br><br>
En caso de no autorizar a Chiesi para tratar sus datos personales en cumplimiento de las Finalidades Secundarias antes expuestas, podrá hacerlo enviando la siguiente declaración vía correo electrónico a e.mejia@chiesi.com conjuntamente con su nombre completo: “No autorizo que mis datos personales sean utilizados para llevar a cabo la(s) finalidad(es) secundaria(s) siguiente(s): (enlistar cada una)”. La revocación será efectiva en la fecha en que se haya acusado la recepción de la notificación.
<br><br>
Derechos que le corresponden respecto a sus datos personales
<br><br>
Usted puede ejercer los derechos de Acceso, Rectificación, Cancelación y Oposición (derechos ARCO) respecto a sus datos personales. El derecho de acceso procede cuando usted requiere saber cuáles de sus datos personales están contenidos en las bases de datos de Chiesi, para qué se utilizan y, en general, las condiciones del tratamiento de sus datos personales; el derecho de rectificación procede cuando usted requiere que se corrijan o actualicen sus datos personales en caso de ser inexactos o incompletos; el derecho de cancelación es procedente cuando se requiere que los datos personales sean dados de baja total o parcialmente de las bases de datos de Chiesi, por haberse cumplido la finalidad para la cual fueron recabados; por último, usted podrá oponerse por causa legítima al tratamiento de sus datos personales.
<br><br>
Usted puede solicitar que se limite el uso o divulgación de sus datos personales y revocar el consentimiento que haya otorgado para el tratamiento de los mismos, siempre y cuando las finalidades no sean necesarias de acuerdo a la relación contractual o por señalamiento expreso en la legislación aplicable.
<br><br>
Como regla general, Chiesi no distribuye su información a terceros autorizados. Asimismo, se compartirá la información personal que sea estrictamente necesaria en cumplimiento a la legislación aplicable o conforme a los requerimientos provenientes de autoridades competentes.
<br><br>
Consentimiento Expreso
<br><br>
Manifiesto que he leído el presente aviso de privacidad, entiendo su contenido y me doy por informado respecto al tratamiento que Chiesi dará a mis datos personales de conformidad con lo que aquí se establece, durante el periodo de la relación con Chiesi y posteriormente, en términos de lo previsto en las leyes aplicables.
<br><br>
Confirmo que he informado a mis familiares o beneficiarios de las cuales he proporcionado datos personales, sobre el tratamiento que se hará de sus datos personales.
<br><br>
            
             </p>
        </div>
      </template>
    <template v-else class="inner">
        <div class="inner">
          <h6 class="ereso" > Términos y condiciones </h6>
          <p class="estas" style="text-align:left">
            Esta es una plataforma con contenidos exclusivos para profesionales de la salud. Queda estrictamente prohibido difundir o reproducir parcial o totalmente cualquier contenido fuera de esta plataforma.
<br><br>
Al entrar y usar esta aplicación web yo confirmo que:<br><br>
Soy un profesional de la salud y que cuento con la instrucción necesaria para acceder e interpretar la información de este portal.
<br><br>
Que el propósito de acceso al presente portal de Chiesi México es con el fin de servir a la comunidad médica, para que el profesional de la salud a quien se le ha entregado el acceso, tenga una herramienta que contribuya a su actualización y práctica diaria, trasladándose así a un beneficio para con sus pacientes.
<br><br>
Que el financiamiento de Chiesi México que permite mi participación y acceso a éste portal/App, no implica un conflicto de interés potencial o real o de cualquier otra índole que afecte o influya el desempeño de mis labores como profesional de la salud, ni en lo personal, ni derivado de mi relación con ninguna institución de salud tanto pública como privada.
<br><br>
Que mis datos personales sean tratados por Chiesi México SA de CV así como por el proveedor contratado para la administración de éste sitio y que ante cualquier duda por el tratamiento de mis datos personales puedo consultar el aviso de privacidad en la página https://www.chiesi.mx/

             </p>
        </div>
    </template>
    
  </el-dialog>
  
        
</template>

<script>
import { useStore } from 'vuex'

import { computed } from 'vue'

export default {
    props:['aviso'],
    setup(props) {
      
      const store = useStore()
      const showTyC = computed(() => store.state.showTyC)
      const showMaterial = computed(() => store.state.showMaterial)
      const checkSintomas = computed(() => store.state.checkSintomas)   
      const mater = () => store.commit('mater')
      const modal = () => store.commit('modal')

      console.log(props)

      return { showTyC, mater, modal,showMaterial,
      checkSintomas} 
    },
}
</script>
<style lang="scss" >
  .dialogado{
    background-color:#000D5A !important;
    border-radius: 30px !important;
    margin-top: 20vh !important;
  }
  .dialogado .el-dialog__headerbtn .el-dialog__close{
    color: #000D5A;
    background-color: #fff;
    padding-top: 3px;
    width: 22px;
    height: 19px;
    border-radius: 22px;
    font-weight: 600;
    margin-right: 15px;
  }
  .dialogado .el-dialog__body {
    padding-top: 15px !important;
  }
  .inner{
      overflow-y: scroll;
      height: 300px;
  }
  .inner::-webkit-scrollbar{
    width: 8px;
    height:10px ;
  }
  .inner::-webkit-scrollbar-track{
    background: transparent;
  }
  .inner::-webkit-scrollbar-thumb{
    background-color: #fff;    /* color of the scroll thumb */
  border-radius: 20px; 
  }
    .ereso{
      color: #fff;
      font-family: "Yusei-Magic";
      font-size: 40px;
      font-style: normal;
      font-weight: 400;
      line-height: 70px;
      letter-spacing: 0em;
      text-align: center;
      margin-top:0px;
      margin-bottom: 20px;
      
      word-break: break-word;
    }
    .estas{
      color: #fff;
      font-family: "Avenir-light";
      font-weight: 100;
      line-height: 30px;
      letter-spacing: 0em;
      text-align: center;
      font-size: 18px;
      padding-left: 5%;
      padding-right: 5%;
      margin-top: 20px;
      word-break: break-word;
      
    }
    .escoge{
      color: #fff;
      width: 280px;
      background-color: transparent;
      border: 1px solid #fff;
      height: 60px;
      font-size: 20px;
      border-radius: 18px;
      margin: 15px;
    }
    .escoge:hover{
      cursor: pointer;
      background-color: #fff !important;
      color: #000D5A;
      font-weight: 600;
      box-shadow: 50px 100px 100px 50px (255,255,255,.6);
    }
    .mup{
      margin-top: 60px;
    }
    @media (max-width:768px) {
      .dialogado{
        width: 90% !important;
        height: 80vh;        
      }
      .inner{
        height: 65vh;
      }
      .dialogado .el-dialog__headerbtn .el-dialog__close{
        margin-right: 0;
      }
    }
      @media (max-width:500px) {
        .dialogado{
          margin: auto;
          width: 95% !important;
          margin-top:50px !important ;
          z-index: 9999999999 !important;
        }
        .estas{
          word-break: break-word;
        }
      }
    
</style>